import { Modal } from 'antd'
import Flex from 'components/Flex'
import React from 'react'
import Button from '../../Button'
import { ShortlistDiv, TextDescription, UploadMsgFlex } from './style'

const CloseRoleDrawer = ({
  description,
  Textdescription,
  Icon,
  showDrawer,
  setShowDrawer,
  onCloseClick,
  loading,
  closeText = 'No',
  YesText = 'Yes',
  showYes = true,
  percentHeight = '28px',
  percentWeight = '451px',
  closeButtonHeight = '38px',
  closeButtonWidth = '64px',
  yesButtonHeight = '38px',
  yesButtonWidth = '64px',
  onApprove,
  setButtonLoading = () => {},
}) => {
  const onClose = () => {
    setShowDrawer(false)
    setButtonLoading(false)
    onCloseClick();
  }

  return (
    <div>
      <Modal
        open={showDrawer}
        centered
        footer={''}
        maskClosable={false}
        closable={false}
        width={700}
        bodyStyle={{
          borderRadius: '20px',
          padding: '20px',
          textAlign: 'center',
          height: '434px',
          width: '700px',
        }}
      >
        <UploadMsgFlex column center centerVertically>
          <Icon></Icon>
          <ShortlistDiv
            percentHeight={'max-height'}
            percentWeight={percentWeight}
          >
            {description}
          </ShortlistDiv>
          {Textdescription && (
            <TextDescription> {Textdescription}</TextDescription>
          )}

          <Flex style={{ gap: '10px' }}>
            <Button.Secondary
              text={closeText}
              width={closeButtonWidth}
              height={closeButtonHeight}
              onClick={onClose}
            />
            {showYes && (
              <Button.Primary
              text={YesText}
              width={yesButtonWidth}
              height={yesButtonHeight}
              onClick={() => {
                if (onApprove) {
                  onApprove();
                }
                if (onCloseClick) {
                  onCloseClick();
                }
                setShowDrawer(false);
              }}
            />
            )}
          </Flex>
        </UploadMsgFlex>
      </Modal>
    </div>
  )
}

export default CloseRoleDrawer
